import type { Point } from "#public"
import type { Measure, Radian } from "#public"

import { Cos, Sin } from "./Math"

/**
 * Rotates a point around a center point by the specified angle
 */
export const Rotate = <T extends Measure>(cx: T, cy: T, x: T, y: T, angle: Radian): Point<T> => {
  if (angle) {
    const cos = Cos(angle)
    const sin = Sin(angle)
    return {
      x: (cos * (x - cx) + sin * (y - cy) + cx) as T,
      y: (cos * (y - cy) - sin * (x - cx) + cy) as T,
    }
  }
  return { x, y }
}
